import { Label as PrimerLabel, LabelProps as PrimerLabelProps } from '@primer/react';
import { PropsWithChildren } from 'react';

type Props = {} & PrimerLabelProps;

const Label = ({ ...props }: PropsWithChildren<Props>) => <PrimerLabel {...props} />;

export default Label;
export type { Props as LabelProps };
